import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { BOOK_NOW_URL, isExternalBookingURL } from "@/config/booking";
import { TRACK_IS_CLOSED, CLOSURE_CONTACT_URL } from "@/config/trackStatus";

/**
 * Returns a handler that opens the configured booking URL.
 * External URLs open in a new tab; internal routes use react-router.
 */
export function useBookNow() {
  const navigate = useNavigate();
  return useCallback(() => {
    // Temporary closure: contact only. The original booking destination is preserved.
    if (TRACK_IS_CLOSED) {
      navigate(CLOSURE_CONTACT_URL);
      window.scrollTo({ top: 0, behavior: "instant" });
    } else if (isExternalBookingURL()) {
      window.open(BOOK_NOW_URL, "_blank", "noopener,noreferrer");
    } else {
      navigate(BOOK_NOW_URL);
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [navigate]);
}
